import React from 'react';
import { Building2, Users, FileText, Receipt, Package, GraduationCap, LayoutList, MessageSquare, Zap, Activity, Calendar, Stethoscope, PackageOpen, BookOpen } from 'lucide-react';

export type MainMenuId = 'customer' | 'sales' | 'assets' | 'site';
export type SubMenuId =
    | 'organizations'
    | 'users'
    | 'resources'
    | 'orders'
    | 'products'
    | 'class'
    | 'scenarios'
    | 'dialogue'
    | 'task'
    | 'action'
    | 'events'
    | 'symptoms'
    | 'items'
    | 'blog';

export interface SubMenuItem {
    id: SubMenuId;
    label: string;
    icon: React.ComponentType<{ size?: number; className?: string }>;
}

export const MAIN_MENUS: { id: MainMenuId; label: string }[] = [
    { id: 'customer', label: '고객관리' },
    { id: 'sales', label: '판매관리' },
    // 콘텐츠 관리(assets) 메뉴 숨김
    { id: 'site', label: '사이트 관리' },
];

export const SUB_MENUS: Record<MainMenuId, SubMenuItem[]> = {
    customer: [
        { id: 'organizations', label: '기관관리', icon: Building2 },
        { id: 'users', label: '사용자 관리', icon: Users },
    ],
    sales: [
        { id: 'orders', label: '주문관리', icon: Receipt },
        { id: 'products', label: '프로덕트 관리', icon: Package },
        { id: 'class', label: '클래스 관리', icon: GraduationCap },
        { id: 'scenarios', label: '시나리오 관리', icon: LayoutList },
    ],
    assets: [
        { id: 'dialogue', label: '대화관리', icon: MessageSquare },
        { id: 'task', label: '스킬관리', icon: Zap },
        { id: 'action', label: '액션관리', icon: Activity },
        { id: 'events', label: '이벤트 관리', icon: Calendar },
        { id: 'symptoms', label: '증상 템플릿 관리', icon: Stethoscope },
        { id: 'items', label: '아이템 관리', icon: PackageOpen },
    ],
    site: [
        { id: 'resources', label: '자료실', icon: FileText },
        { id: 'blog', label: '블로그', icon: BookOpen },
    ],
};
